import api from './api';

class SpotService {
  // Obtenir les paires de trading
  async getTradingPairs() {
    const response = await api.get('/spot/pairs');
    return response.data;
  }

  // Créer un ordre spot
  async createOrder(orderData) {
    const response = await api.post('/spot/orders', orderData);
    return response.data;
  }

  // Obtenir les ordres de l'utilisateur
  async getUserOrders(params = {}) {
    const response = await api.get('/spot/orders', params);
    return response.data;
  }

  // Annuler un ordre
  async cancelOrder(orderId) {
    const response = await api.delete(`/spot/orders/${orderId}`);
    return response.data;
  }
}

const spotService = new SpotService();
export default spotService;